import { Box, Flex, Text } from '@chakra-ui/react';
import styles from './dataPointsBlock.module.css';

import { ReportsIcon } from '@spotoninc/nexus-web-assets';
import { toAmountString } from '../tasks.utils';

function DataPointsBlock({ data, summary, containerClassName = '' }) {
  return (
    <Flex
      direction="column"
      p={6}
      gap={4}
      rounded="xl"
      className={`${styles.container} ${containerClassName}`}
    >
      <Flex direction={'row'} alignItems={'center'} gap={3}>
        <ReportsIcon className={styles.icon} />
        <Box className={styles.title}>Data Points</Box>
      </Flex>
      <Box>{summary}</Box>
      <Box>
        <Text className={styles.sectionTitle}>Historical Costs</Text>
        <Flex direction={'column'} gap={1} pt={1}>
          <Flex
            direction={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            className={styles.item}
            gap={3}
          >
            <Box className={styles.text}>{'Current Period'}</Box>
            <Box className={styles.text}>
              {`${toAmountString(data?.current_period?.amount || '0')} (${data?.current_period?.percentage_of_revenue || '0'}%)`}
            </Box>
          </Flex>
          <Flex
            direction={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            className={styles.item}
            gap={3}
          >
            <Box className={styles.text}>{'Last Period'}</Box>
            <Box className={styles.text}>
              {`${toAmountString(data?.last_period?.amount || '0')} (${data?.last_period?.percentage_of_revenue || '0'}%)`}
            </Box>
          </Flex>
          <Flex
            direction={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            className={styles.item}
            gap={3}
          >
            <Box className={styles.text}>{'Same Period Last Year'}</Box>
            <Box className={styles.text}>
              {`${toAmountString(data?.same_period_last_year?.amount || '0')} (${data?.same_period_last_year?.percentage_of_revenue || '0'}%)`}
            </Box>
          </Flex>
          <Flex
            direction={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            className={styles.item}
            gap={3}
          >
            <Box className={styles.text}>{'Two Periods Ago'}</Box>
            <Box className={styles.text}>
              {`${toAmountString(data?.two_periods_ago?.amount || '0')} (${data?.two_periods_ago?.percentage_of_revenue || '0'}%)`}
            </Box>
          </Flex>
        </Flex>
      </Box>
    </Flex>
  );
}

export default DataPointsBlock;
